import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";

const DeleteButton: FunctionComponent<{ Id: any, onDelete: any, className: string, text: string }> = (props) => {

    const modalId = `dropModal_${props.Id}`;
    const { t } = useTranslation();

    const HandleDropUser = () => {
        props.onDelete(props.Id)
    }

    return (<>

        <button type="button" className={props.className} data-bs-toggle="modal"
            data-bs-target={`#${modalId}`} >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_168_187)">
                    <path d="M3.33398 5.83334H16.6673" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8.33398 9.16666V14.1667" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M11.666 9.16666V14.1667" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M4.16602 5.83334L4.99935 15.8333C4.99935 16.2754 5.17494 16.6993 5.4875 17.0119C5.80007 17.3244 6.22399 17.5 6.66602 17.5H13.3327C13.7747 17.5 14.1986 17.3244 14.5112 17.0119C14.8238 16.6993 14.9994 16.2754 14.9994 15.8333L15.8327 5.83334" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_168_187">
                        <rect width="20" height="20" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </button>


        <div className="modal fade" id={modalId} aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="title-18">{t("propertiesPage.confirmation")}</h5>
                    </div>
                    <div className="modal-body mb-3 mt-3">
                        <p className="para-16  text-start"> {props.text}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="button-dash btn-outline-secondary back-trans padd-15 padd-5-15-mb marg-right-16" data-bs-dismiss="modal">
                            {t("propertiesPage.no")}
                        </button>
                        <button type="button" data-bs-dismiss="modal" className="button-dash padd-15 padd-5-15-mb btn-danger" onClick={HandleDropUser}>
                            {t("propertiesPage.yes")}</button>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default DeleteButton;
